import { FieldErrors } from 'react-hook-form'

export const errorMessageByField = (field: string, errors: FieldErrors) => {
  return errors[field] ? errors[field]?.message : ""
}
